/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { checkDoesObjectHaveContent, deepCopy, toNumber, setNull, deleteCookie } from "../components/Common";
import { Palette } from "../AppConfig";
import Drawer from "@material-ui/core/Drawer";
import * as BSL_Common from "../components/BSL_CommonControls";
import BSL_TextInput from "../components/BSL_TextInput";
import { Grid, IconButton } from "@material-ui/core";
import { saveUserToWeb } from "../redux_store/appState";
import { checkJobStateValidationSchema } from "../redux_store/jobState";
import DeleteIcon from "@material-ui/icons/Delete";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_Button from "../components/BSL_Button";
import ManageBusiness from "./ManageBusiness/ManageBusiness";
import Message from "../components/Message";

const useStyles = makeStyles({
    root: {
        paddingRight: "10px",
        position: "fixed",
        right: "0px",
        top: "0px",
        height: "100%",
        width: "500px",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        backgroundColor: "#edf0f3e8",
        borderLeft: "3px solid #0000001f",
        backdropFilter: "blur(4px)",
        flexDirection: "column",
        overflow: "auto",
    },

    col_header: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
        fontSize: "12px",
        fontFamily: '"Univers45", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: "200",
        textAlign: "center",
        padding: "5px 0px",
    },

    row_header: {
        display: "flex",
    },

    row_style: {
        padding: "0px 4px !important",
    },

    row_cell: {
        textAlign: "center",
        display: "flex",
    },

    admin_drawer_root: {
        top: "0px",
        left: "0px",
        width: "95%",
        height: "-webkit-fill-available",
        display: "flex",
        overflow: "hidden",
        position: "fixed",
        textAlign: "left",
        borderLeft: "3px solid #0000001f",
        borderRadius: "0px",
        flexDirection: "column",
        backdropFilter: "blur(4px)",
        backgroundColor: "#edf0f3e8",
    },
});

export const LogOut = ({ dispatch }) => {
    deleteCookie("CDS_token");
    localStorage.clear();
    dispatch({
        type: "LOG_OUT",
    });
    localStorage.clear();
    setTimeout(function () {
        localStorage.clear();
        window.location.reload();
    }, 1000);
};

export default function ManageUser(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.app?.user);
    const validationSchema = useSelector((state) => state?.config?.validationSchema);
    const [newUser, setNewUser] = React.useState(null);
    const [errorState, setErrorState] = React.useState(null);
    const [showMessage, setShowMessage] = React.useState(false);
    const [deleteKey, setDeleteKey] = React.useState(null);
    const [deleteName, setDeleteName] = React.useState(null);
    const [newMarkup, seNewMarkup] = React.useState("");
    const [adminDrawer, setAdminDrawer] = React.useState(null);
    const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(false);

    React.useEffect(() => {
        setNewUser(user);

        let newErrorState = setNull(user);
        for (let param in user) {
            if (validationSchema?.Customer?.[param]) {
                let error = "";
                error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, user[param]);
                newErrorState[param] = error;
            }
        }
        for (let param in user?.BusinessDetails) {
            if (validationSchema?.Distributor?.[param]) {
                let error = "";
                error = checkJobStateValidationSchema(
                    validationSchema,
                    "Distributor",
                    null,
                    param,
                    user?.BusinessDetails?.[param]
                );
                newErrorState.BusinessDetails[param] = error;
            }
        }
        setErrorState(newErrorState);
    }, [user, props.open]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const saveUser = () => {
        //check no errors
        let errors_has_content = checkDoesObjectHaveContent(errorState);

        if (errors_has_content) {
            setShowMessage({
                type: "error",
                message: "Error: [" + errors_has_content.key + "] " + errors_has_content.value,
            });
            return;
        }

        dispatch(saveUserToWeb(newUser, true, true));
        props.toggleDrawer();
    };

    const setErrorStateBusiness = (businessErrorState) => {
        let newErrorState = deepCopy(errorState);
        newErrorState.BusinessDetails = businessErrorState;
        setErrorState(newErrorState);
    };

    const updateNewUser = (param) => (e) => {
        let val = e;
        if (val?.target?.value !== undefined) val = val?.target?.value;

        let updateUser = deepCopy(newUser);
        updateUser[param] = val;
        setNewUser(updateUser);

        // validate using customer validation schema
        if (validationSchema?.Customer?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, val);
            let newErrorState = deepCopy(errorState);
            newErrorState[param] = error;
            setErrorState(newErrorState);
        }
    };

    const updateNewUserBusiness = (param) => (e) => {
        let updateUser = deepCopy(newUser);
        let val = e;
        if (val?.target?.value !== undefined) val = val?.target?.value;
        updateUser.BusinessDetails[param] = val;
        setNewUser(updateUser);

        // validate using customer validation schema
        if (validationSchema?.Distributor?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Distributor", null, param, val);
            let newErrorState = deepCopy(errorState);
            newErrorState.BusinessDetails[param] = error;
            setErrorState(newErrorState);
        }
    };

    const setCurrentBusiness = (newBusinessDetails) => {
        let updateUser = deepCopy(newUser);
        updateUser.BusinessDetails = deepCopy(newBusinessDetails);
        setNewUser(updateUser);
    };

    const updateMarkup = (key, param, value) => {
        let updateUser = deepCopy(newUser);
        updateUser.BusinessDetails.MarkupStructure.Markups[key][param] = value;
        setNewUser(updateUser);
    };

    const deleteMarkup = (key) => {
        let updateUser = deepCopy(newUser);
        delete updateUser.BusinessDetails.MarkupStructure.Markups[key];
        setNewUser(updateUser);
        setDeleteKey(null);
    };

    const addMarkup = (key) => {
        if (key === "") return;
        if (newUser.BusinessDetails.MarkupStructure.Markups[key]) return;
        let updateUser = deepCopy(newUser);
        updateUser.BusinessDetails.MarkupStructure.Markups[key] = {
            DisplayName: key,
            Material: 100,
            Installation: 100,
            PackingAndDel: 0,
            Commission: 0,
        };
        setNewUser(updateUser);
        seNewMarkup("");
    };

    const updatePaymentStructure = (param, value) => {
        let updateUser = deepCopy(newUser);
        updateUser.BusinessDetails.MarkupStructure.PaymentStructure[param] = value;
        setNewUser(updateUser);
    };

    const LoadAdminTool = (tool) => {
        if (tool === "Colour List") {
            setAdminDrawer(tool);
        }
    };

    if (!user || !newUser) return <></>;

    const markups = newUser.BusinessDetails.MarkupStructure.Markups;
    const paymentStructure = newUser.BusinessDetails.MarkupStructure.PaymentStructure;

    let customer_types = [];
    if (markups)
        for (let key in markups) {
            let item = markups[key];
            customer_types.push({
                Key: key,
                Display: item?.DisplayName ? item.DisplayName : key,
            });
        }

    let markup_rows = [];

    let input_style = { padding: "0px", margin: "1px" };

    for (let key in markups) {
        let markup = markups[key];
        markup_rows.push(
            <Grid key={key} container item xs={12} spacing={0} className={classes.row_style}>
                <Grid item xs={4}>
                    <div className={classes.row_header}>
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                setDeleteName(markup?.DisplayName ? markup?.DisplayName : key);
                                setDeleteKey(key);
                            }}
                        >
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        <BSL_TextInput
                            value={markup?.DisplayName ? markup?.DisplayName : key}
                            preValidate="alphaNumeric"
                            tight
                            style={input_style}
                            onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                        />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        <BSL_TextInput
                            value={markup.Material}
                            tight
                            min={0}
                            max={200}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) => updateMarkup(key, "Material", val)}
                        />
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.Installation}
                            tight
                            min={0}
                            max={200}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) => updateMarkup(key, "Installation", val)}
                        />{" "}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.PackingAndDel}
                            tight
                            min={0}
                            max={200}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) => updateMarkup(key, "PackingAndDel", val)}
                        />{" "}
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.row_cell}>
                        {" "}
                        <BSL_TextInput
                            value={markup.Commission}
                            tight
                            min={0}
                            max={200}
                            endAdornment="%"
                            style={input_style}
                            onBlur={(val) => updateMarkup(key, "Commission", val)}
                        />{" "}
                    </div>
                </Grid>
            </Grid>
        );
    }

    return (
        <Drawer anchor="right" open={props.open} onClose={props.toggleDrawer}>
            <div className={classes.root}>
                <div style={{ minHeight: "30px" }}></div>

                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionHeader>User Settings</BSL_Common.SectionHeader>
                    {user?.apiKey != null && (
                        <>
                            <BSL_Common.SectionRow style={{ fontSize: "small", margin: "-10px 8px" }}>
                                <p>
                                    API KEY: <b>{user?.apiKey}</b>
                                </p>
                            </BSL_Common.SectionRow>
                        </>
                    )}
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Display Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.DisplayName}
                            onBlur={updateNewUser("DisplayName")}
                            error={errorState?.DisplayName}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="First Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.FirstName}
                            onBlur={updateNewUser("FirstName")}
                            error={errorState?.FirstName}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="Last Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.LastName}
                            onBlur={updateNewUser("LastName")}
                            error={errorState?.LastName}
                            helperText={"*sync with Salesforce"}
                        />
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Email"
                            tight
                            disabled
                            value={newUser.Email}
                            onBlur={updateNewUser("Email")}
                            error={errorState?.Email}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="Phone"
                            tight
                            disabled
                            value={newUser.Phone}
                            onBlur={updateNewUser("Phone")}
                            error={errorState?.Phone}
                            helperText={"*sync with Salesforce"}
                        />
                    </BSL_Common.SectionRow>
                </BSL_Common.SectionContainer>
                {toNumber(user?.Role) >= 9 && (
                    <ManageBusiness
                        BusinessDetails={newUser.BusinessDetails}
                        UpdateBusiness={setCurrentBusiness}
                        ErrorState={errorState.BusinessDetails}
                        SetErrorState={setErrorStateBusiness}
                        sourcePage={"ManageUser"}
                        setSaveButtonDisabled={setSaveButtonDisabled}
                    />
                )}

                <BSL_Common.SectionRow
                    style={{
                        justifyContent: "center",
                        marginTop: "20px",
                    }}
                >
                    <BSL_Button label="Save Changes" onClick={saveUser} disabled={saveButtonDisabled} />
                    <BSL_Button label="Cancel" style={{ marginLeft: "24px" }} onClick={props.toggleDrawer} secondary />
                </BSL_Common.SectionRow>

                <BSL_Common.SectionContainer
                    style={{
                        justifyContent: "center",
                        marginTop: "20px",
                    }}
                >
                    <BSL_Button
                        onClick={() => LogOut({ dispatch })}
                        secondary
                        style={{
                            alignSelf: "center",
                        }}
                    >
                        Log Out
                    </BSL_Button>
                </BSL_Common.SectionContainer>

                <div style={{ minHeight: "20px" }}></div>
            </div>
            <BSL_Dialog
                title="Delete Markup?"
                open={deleteKey}
                onClose={() => setDeleteKey(null)}
                button1Text="Delete"
                button1Click={() => deleteMarkup(deleteKey)}
                button2Text="No"
                button2Click={() => setDeleteKey(null)}
            >
                <div style={{ display: "flex" }}>
                    <div>Are you sure you would like to delete this markup ({deleteName})?</div>
                </div>
            </BSL_Dialog>

            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </Drawer>
    );
}